import $ from "jquery";
import socket from "../utlis/socket";
import rsaWrapper from "../utlis/rsa-wrapper";
import aesWrapper from "../utlis/aes-wrapper";
import store from "store";
import { ToastContainer, toast } from "react-toastify";
import { apiURL } from "../utlis/config";
// import { toast } from "react-toastify";
//updateMyCartTraining
// const apiURL = "http://localhost:8080";
// const apiURL = "http://172.105.35.119:8080/api";
var Actions = {
  socketConnect() {
    socket.connect();
    return new Promise((resolve, reject) => {
      socket.on("CLIENT_PRIVATE_KEY", (privateKey) => {
        // socket.emit("SECRET_KEY");
        socket.on("SECRET_KEY", (key) => {
          console.log({ key });
          rsaWrapper
            .privateDecrypt(privateKey, key)
            .then((SECRET_KEY) => {
              var AESKey = SECRET_KEY;
              console.log({ AESKey });
              store.set("AESKey", SECRET_KEY);
              resolve(SECRET_KEY);
              // they.setState({ connection: true, AESKey });
              // if (window.requestIdleCallback) {
              //   const fingerprint = btoa(navigator.userAgent);
              //   //console.log(
              //     fingerprint,
              //     "---",
              //     navigator.userAgent,
              //     "fingerPrint"
              //   );
              //   // cookie.set("fngprt", fingerprint);
              //   cookie.set("fngprt", fingerprint, {
              //     secure: process.env.NODE_ENV !== "dev"
              //   });
              //   //console.log(cookie.get("fngprt"), "get");
              // } else {
              //   const fingerprint = btoa(navigator.userAgent);
              //   //console.log(
              //     fingerprint,
              //     "---",
              //     navigator.userAgent,
              //     "fingerPrint"
              //   );
              //   // cookie.set("fngprt", fingerprint);
              //   cookie.set("fngprt", fingerprint, {
              //     secure: process.env.NODE_ENV !== "dev"
              //   });
              //   //console.log(cookie.get("fngprt"), "get");
              // }
            })
            .catch((err) => {
              //console.log("error occurred ", err.name);
              //console.log("error occurred code ", err.code);
            });
        });
      });
    });
  },
  emailAuthentication: (email, password) => {
    toast.dismiss();
    //console.log({ email, password, apiURL});
    return new Promise((resolve, reject) => {
      var url = apiURL + "/admin/login";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "POST",
        headers: {
          // Authorization: "Bearer " + store.get("accessToken")
          // fngprt: m.cookie.get("fngprt")
        },
        data: {
          email: email,
          password: password,
        },
        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 1500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 1000 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error("Your session has been expired. Please relogin.", {
              position: toast.POSITION.TOP_CENTER,
            });
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error("Some error has occurred.", {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  checkPing: () => {
    // toast.dismiss()
    return new Promise((resolve, reject) => {
      var url = apiURL + "/ping";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          //   Authorization: "Bearer " + localStorage.getItem("accessToken")
          // fngprt: m.cookie.get("fngprt")
        },

        success: function (response) {
          // // response = JSON.parse(response);
          if (response.error) {
            // toast.error(response.memberMessage);
            localStorage.clear();
            window.location.reload();
          } else {
            store.set("staffMember", response.data.staffMember);
            store.set("enquiries", response.enquiries);
            var event = new CustomEvent("enquiries", {
              detail: { enquiries: response.enquiries || [] },
            });
            document.dispatchEvent(event);
            // toast.info(response.memberMessage)
          }
          console.log({ response });
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // toast.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // toast.error("Some error has occurred.");
          }
        },
      };

      $.ajax(settings).done();
    });
  },
};

export default Actions;
